import {EmblaIcon} from '../emblaIcon/emblaIcon';
import React, {useState} from 'react';
import DynamicButton from './dynamicButton';
import { EmblaIconsType } from 'core/emblaIcons';
import classNames from "classnames";
import { Localizer } from 'infrastructure/localization/localizer';

export type ConfirmButtonProps = {
    icon: EmblaIconsType;
    asButton?: boolean;
    isPrimary?: boolean;
    isDanger?: boolean;
    buttonTekst?: string;
    additionalClasses?: string;
    additionalConfirmDenyClasses?: string;
    confirmCallback: () => void;
    useDynamicButton?: boolean;
    disabled?: boolean;

    ariaText?: string; // This should be sat if buttonText is undefined.
}

export function ConfirmButton({useDynamicButton=false, disabled=false, additionalConfirmDenyClasses, ...props}: ConfirmButtonProps) {
    const [confirmationActive, setConfirmationActive] = useState(false);

    const confirm = async (confirmed: boolean, event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        if (confirmed) {
            setConfirmationActive(true)
            props.confirmCallback();
        } else
            setConfirmationActive(false);
    }

    const handleOnClick = (event: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        setConfirmationActive(true);
    }

    const ariaLabel = props.ariaText ?? props.buttonTekst;

    const render = (
        <>
            {!confirmationActive &&

                <>
                    {useDynamicButton
                        ?
                            <DynamicButton onClick={(event) => handleOnClick(event)} additionalClasses={props.additionalClasses} disabled={disabled} ariaLabel={ariaLabel}>
                                <DynamicButton.TextIconItem iconName={props.icon} text={props.buttonTekst}/>
                            </DynamicButton>
                        :
                            <div className={classNames(props.asButton && "btn", props.isPrimary ? "btn-primary" : props.isDanger ? "btn-danger" : "btn-default", props.additionalClasses)} role='button'
                                aria-label={ariaLabel}
                                onClick={(event) => handleOnClick(event)}>
                                {props.buttonTekst &&
                                    <>{props.buttonTekst}</>
                                }
                                <EmblaIcon iconName={props.icon} />
                            </div>
                    }
                </>

            }

            {confirmationActive &&
                <div className={classNames("btn-group confirm ", props.additionalClasses)} role="group">
                    <button aria-label={Localizer.aria_label_ClickToNegate()} type="button" className={classNames("btn btn-danger btn-icon btn-outline", additionalConfirmDenyClasses)}
                            onClick={(event) => confirm(false, event)}>
                        <EmblaIcon iconName='danger'/>
                    </button>
                    <button aria-label={Localizer.aria_label_ClickToConfirm()} type="button" className={classNames("btn btn-success btn-icon btn-outline", additionalConfirmDenyClasses)}
                            onClick={(event) => confirm(true, event)}>
                        <EmblaIcon iconName='success'/>
                    </button>
                </div>
            }
        </>
    )

    return <>{render}</>
}
